import {i18n} from 'src/shared/config'
import type {Paymethod} from 'src/shared/types'

export function usePaymentTitle(method: Paymethod) {
  switch (method) {
    case 'already_paid':
      return i18n('ndd.payment.already_paid', 'Оплата не нужна')
    case 'card_on_receipt':
      return i18n('ndd.payment.card_on_receipt', 'Картой при получении')
    case 'cash_on_receipt':
      return i18n('ndd.payment.cash_on_receipt', 'Наличными при получении')
    case 'cashless':
      return i18n('ndd.payment.cashless', 'Безналичная оплата')
    case 'kassa_on_receipt':
    default:
      return ''
  }
}
